// src/pages/ExamUnionHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const ExamUnionHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  // const isLogged = authState?.isLogged || false;
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "Warrior";

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const quickLinks = [
    { label: "Buy Series", emoji: "💳", link: "/examunion-buyseries", color: "from-amber-500 to-yellow-500" },
    { label: "Practice Test Series", emoji: "🎯", link: "/examunion-practice", color: "from-emerald-500 to-cyan-500" },
    { label: "Practice PYQ Pattern", emoji: "📜", link: "/examunion-practice", color: "from-purple-500 to-pink-500" },
    { label: "Live AITS", emoji: "⚡", link: "/examunion-liveaits", color: "from-orange-500 to-red-500" },
    { label: "My Rank", emoji: "🏆", link: "/examunion-myrank", color: "from-yellow-400 to-amber-500" },
    { label: "Top Rankers", emoji: "👑", link: "/examunion-rankers", color: "from-cyan-400 to-purple-500" },
  ];

  const allFeatures = [
    { label: "Exams List", emoji: "💳", link: "/examunion-examslist" },
    { label: "Join ExamUnion", emoji: "🤝", link: "/examunion-join" },
    { label: "Immersive Books", emoji: "📚", link: "/examunion-bookworld" },
    { label: "Digital Bookshelf", emoji: "🗂️", link: "/bookshelf" },
    { label: "Digital Notebook", emoji: "📒", link: "/bookshelf" },
    { label: "Parent / Mentor Zone", emoji: "👨‍👩‍👧", link: "/examunion-mentorzone" },
    { label: "Create & Monetise", emoji: "🛠️", link: "/examunion-create-set" },
    { label: "Suggest Question", emoji: "✍️", link: "/examunion-suggestquest" },
    { label: "Deep Thinking", emoji: "🧠", link: "/fivewhys-analysis-home" },
    { label: "AI Counselling", emoji: "🤖", link: "/aicounselling" },
    { label: "My Chronicles", emoji: "📔", link: "/life-chronicles-home" },
    { label: "Applause", emoji: "👏", link: "/applause-hub-home" },
    { label: "POV", emoji: "🎥", link: "/povify-home" },
    { label: "Marketplace", emoji: "🛒", link: "/khareedo" },
    { label: "eduTube", emoji: "🎥", link: "/edutube" },
    { label: "Faculties", emoji: "🧑‍💼", link: "/examunion-faculties"},
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-zinc-950 via-black to-zinc-950 text-white font-sans overflow-x-hidden">
      {/* Modern Sticky Header */}
      <header className="sticky top-0 z-50 bg-black/90 backdrop-blur-xl border-b border-white/10 px-1 py-2 flex items-center justify-between">
        <div className="flex flex-col justify-left">
          <div className="flex text-lg lg:text-xl font-extrabold text-yellow-200">
            🔬 ExamUnion
          </div>
          <div className="text-[10px] lg:text-sm">
            Foundation to Examdays - Global Self & Group Test Series All-in-one battle arena.  
          </div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-zinc-900 border-b border-white/10 px-5 py-6 animate-fadeIn">
          {isLoggedIn ? (
            <div className="flex flex-col gap-4 items-center">
              <p className="text-lg font-medium">{userName}</p>
              <button onClick={handleLogout} className="w-full py-3 bg-red-600 rounded-2xl font-medium">
                ⏻
              </button>
            </div>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="w-full py-3 bg-white text-black rounded-2xl font-semibold"
            >
              🔐
            </button>
          )}
        </div>
      )}

      {/* 🔥 Your Cyan Navigation Bar - Now Beautiful & Mobile-First */}
      <div className="bg-gradient-to-r from-cyan-700 via-cyan-600 to-teal-600 text-white text-sm py-1 shadow-inner">
        <div className="px-2 flex flex-wrap justify-center gap-x-1 gap-y-1">
          <a href="/examUnion-about" className="text-xs lg:text-sm hover:text-yellow-200 transition-colors flex items-center gap-1.5">
            🧠 <span>About</span>
          </a>
          <a href="/examunion-rankers" className="text-xs lg:text-sm hover:text-yellow-200 transition-colors flex items-center gap-1.5">
            🏆 <span>Rankings</span>
          </a>
          <a href="/examunion-earning-estimator" className="text-xs lg:text-sm hover:text-yellow-200 transition-colors flex items-center gap-1.5">
            💰 <span>Pocket Money</span>
          </a>
          <a href="" className="text-xs lg:text-sm hover:text-yellow-200 transition-colors flex items-center gap-1.5">
            ⭐🛒 <span>ScoreKart</span>
          </a>
        </div>
      </div>

      {/* Hero Banner */}
      <div className="relative h-24 lg:h-32 flex items-center justify-center overflow-hidden bg-black">
        <div className="absolute inset-0 bg-[radial-gradient(at_center,#22d3ee_0%,transparent_70%)] opacity-20"></div>
        <div className="text-center px-6 z-10">
          <h1 className="text-sm lg:text-lg font-normal mb-1">
            Built for fighters who refuses to settle.
          </h1>
          <p className="text-emerald-300 text-xs lg:text-sm">
            JEE • NEET • UPSC • UGC NET • All India Entrance • State Level Entrance • Special Entrance • India First. Made for the World
          </p>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-emerald-400 to-transparent"></div>
      </div>

      {/* Quick Access Cards */}
      <div className="px-4 mt-2 relative z-10">
        <div className="grid grid-cols-3 lg:grid-cols-6 gap-1">
          {quickLinks.map((item, idx) => (
            <button
              key={idx}
              onClick={() => navigate(item.link)}
              className={`group bg-zinc-900 hover:bg-zinc-800 border border-white/10 rounded-xl p-2 transition-all active:scale-[0.97] flex flex-col items-center gap-1 shadow-xl shadow-black/50`}
            >
              <div className={`w-8 h-8 lg:w-14 lg:h-14 rounded-md lg:rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center text-[13px] lg:text-2xl transition-transform group-active:rotate-12`}>
                {item.emoji}
              </div>
              <p className="text-gray-300 text-[11px] lg:text-sm font-semibold text-center leading-tight">{item.label}</p>
            </button>
          ))}
        </div>
      </div>

      {/* All Features Grid */}
      <div className="px-4 pt-4 pb-10">
        <div className="flex items-center justify-between mb-4 px-2 bg-cyan-800 py-1">
          <h2 className="text-gray-300 text-sm lg:text-xl font-bold tracking-tight">Explore Everything</h2>
          <div className="text-xs lg:text-sm uppercase tracking-widest text-yellow-400">Tap • Engage • Grow</div>
        </div>

        <div className="grid grid-cols-3 lg:grid-cols-6 gap-2">
          {allFeatures.map((feature, index) => (
            <button
              key={index}
              onClick={() => navigate(feature.link)}
              className="group bg-zinc-900/80 hover:bg-zinc-800 border border-white/5 hover:border-emerald-500/30 rounded-3xl p-2 transition-all duration-300 active:scale-95 flex flex-col items-center text-center gap-1 shadow-inner"
            >
              <div className="w-10 h-10 lg:w-14 lg:h-14 rounded-xl text-lg lg:text-2xl transition-transform group-hover:scale-110 group-active:rotate-6">
                {feature.emoji}
              </div>
              <p className="font-medium text-xs lg:text-sm leading-tight text-emerald-100 group-hover:text-white">
                {feature.label}
              </p>
            </button>
          ))}
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-black border-t border-white/10 py-8 px-4 text-center text-xs text-zinc-400">
        <div className="max-w-md mx-auto">
          © 2026 ExamUnion • Built for fighters who refuse to settle.<br />
          <div className="flex justify-center gap-6 mt-6 text-sm">
            <Link to="/about-us" className="hover:text-emerald-400 transition">About</Link>
            <Link to="/privacy-policy" className="hover:text-emerald-400 transition">Privacy</Link>
            <Link to="/terms-of-use" className="hover:text-emerald-400 transition">Terms</Link>
            <Link to="/contact-us" className="hover:text-emerald-400 transition">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ExamUnionHome;